import React from 'react'
import { inject, observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import { withTranslation } from 'react-i18next'

const EmptyTargetGroupAnalysisView = ({ selectionStore, t }) => (
  <div className='analysis-container'>
    <div className='analysis'>
      <section>
        <div className='analysis-header nowrap'>
          <h3>
            <Icon extraClasses={['icon-lg']} id='fa-area-chart' />
            <span>{selectionStore.item.name}</span>
            <span className='note'>{t('TARGET_GROUP.NO_REGIONS')}</span>
          </h3>
        </div>
      </section>
    </div>
  </div>
)

export default withTranslation()(inject('selectionStore')(observer(EmptyTargetGroupAnalysisView)))
